import { ReducerData } from '../rootReducer';
import { AuthStates } from './types';

export function selectUserData(state: ReducerData) {
	return state.userData;
}

export function selectUserEmail(state: ReducerData) {
	return state.userData.email;
}

export function selectIsAuthenticated(state: ReducerData) {
	return state.userData.authState === AuthStates.ALLOWED;
}

export function selectAuthState(state: ReducerData) {
	return state.userData.authState;
}

export function selectMpoeLink(state: ReducerData) {
	return state.userData.mpoeApplicationUrl;
}

export function commanderLink(state: ReducerData) {
	return state.userData.bridgeCommanderLink;
}

export function isBillingGroupPermission(state: ReducerData) {
	return state.userData.permissions.canViewBridgePaymentSettings;
}

export function isUsersPermission(state: ReducerData) {
	return state.userData.permissions.canViewBridgeBasicInformation;
}

export function isExpandedGroupPermission(state: ReducerData) {
	return state.userData.permissions.canViewBridgeExpandedInformation;
}

export function isEmployeeDashboardPermission(state: ReducerData) {
	return state.userData.permissions.canViewEmployeesDashboard;
}

export function isViewHistoryOfAllEmployeesPermission(state: ReducerData) {
	return state.userData.permissions.canViewHistoryOfAllEmployees;
}

export function isViewAccountsListPermission(state: ReducerData) {
	return state.userData.permissions.bridgeFull;
}

export function isUpdateBridgeBasicInformationPermission(state: ReducerData) {
	return state.userData.permissions.canUpdateBridgeBasicInformation;
}
